import React from 'react'
import { Tab, Row, Nav, Col } from 'react-bootstrap'
import { TitleSection } from '../../../title-section'
import { FeatureTabContent } from '../../../feature-tab-content'

export const FeatureSection = () => (
  <section id="features" className="features">
    <div className="container">
      <TitleSection title="Features" description="Hauler Next Platform Features" />

      <Tab.Container id="hauler-next-features-tab" defaultActiveKey="offline-entry">
        <Row>
          <Col lg={3}>
            <Nav variant="tabs" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="offline-entry">Offline Ticket Entry</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="ai-capture">AI Pickup Capture</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="barcode-scanning">Barcode Scanning</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="biometric-login">Biometric Login</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="back-office">Back-Office Console</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          <Col lg={9} className="mt-4 mt-lg-0">
            <Tab.Content>
              <Tab.Pane eventKey="offline-entry">
                <FeatureTabContent
                  title="Offline Ticket Entry"
                  subTitle="No network? No problem."
                  description="Drivers create and edit milk pickup and delivery tickets even with no signal. Every ticket, route, and customer is stored on the device and synced to the office with one tap the moment connectivity returns."
                  featureImage="/assets/img/hauler-next/mobile-ticket-detail.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="ai-capture">
                <FeatureTabContent
                  title="AI Pickup Capture"
                  subTitle="Speak it or snap it — the app does the typing."
                  description="Drivers can record a voice note or photograph a paper manifest, and Hauler Next's AI extracts the producers, weights, and grades into a batch review screen to confirm before saving. Enabled per driver from the web console."
                  featureImage="/assets/img/hauler-next/mobile-ai.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="barcode-scanning">
                <FeatureTabContent
                  title="Barcode Scanning"
                  subTitle="Fast, accurate pickup identification."
                  description="The mobile app's built-in camera scanner reads producer and container barcodes to identify pickups instantly — eliminating manual code entry and speeding up every stop."
                  featureImage="/assets/img/hauler-next/mobile-pickup.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="biometric-login">
                <FeatureTabContent
                  title="Biometric Login"
                  subTitle="One look, and you're in."
                  description="Drivers unlock the app with Face ID or Touch ID — no passwords to fumble in the field. The same biometric confirms the driver's signature when closing out a ticket, so sign-offs are fast and verifiably theirs."
                  featureImage="/assets/img/hauler-next/mobile-biometric.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="back-office">
                <FeatureTabContent
                  title="Back-Office Console"
                  subTitle="From the tanker to payroll, all in one browser."
                  description="Track hauled weights, ticket counts, and active drivers on a live dashboard. Open any ticket to review gross/tare/net weights, seal numbers, and driver e-signatures, print a PDF manifest, and push finished tickets straight to payroll — plus license-expiry alerts before a driver is grounded."
                  featureImage="/assets/img/hauler-next/web-ticket-detail.png"
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  </section>
)
